export default __webpack_public_path__ + "static/media/sanchitJain.f3f59f6b.svg";